export default __webpack_public_path__ + "static/media/stop.c190fb47.svg";